import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserSessionService } from '../services/user-session.service';

/** Blocks protected pages without an active session (the session is restored at startup). */
export const authGuard: CanActivateFn = () => {
  const session = inject(UserSessionService);
  return session.isLoggedIn() ? true : inject(Router).parseUrl('/login');
};

/** Keeps signed-in users away from the login page. */
export const guestGuard: CanActivateFn = () => {
  const session = inject(UserSessionService);
  return session.isLoggedIn() ? inject(Router).parseUrl('/dashboard') : true;
};

/**
 * Route data `fncodes: string[]` → the user needs ANY of them. UI-only convenience:
 * the backend enforces the same codes on every API call.
 */
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const session = inject(UserSessionService);
  const required: string[] = route.data['fncodes'] ?? [];
  if (session.hasAnyAccess(required)) return true;
  inject(ToastrService).warning('You do not have access to that page.');
  return inject(Router).parseUrl('/dashboard');
};
